import React, { useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { isAuthenticated } from '../utils/auth'

/**
 * Компонент защищенного маршрута
 * Перенаправляет на страницу входа если пользователь не аутентифицирован
 */
const ProtectedRoute = ({ children, isAuthenticated: isAuthFromProps, setIsAuthenticated: setIsAuthInApp }) => {
  const [isAuth, setIsAuth] = useState(isAuthFromProps) // Используем пропс как начальное состояние
  const [isChecking, setIsChecking] = useState(isAuthFromProps === null) // Если пропс null, значит еще не проверено

  useEffect(() => {
    let isMounted = true
    
    const checkAuth = async () => {
      // Если родитель еще не проверил или мы хотим перепроверить локально
      // Но если родитель уже дал false, нет смысла проверять (или есть? для надежности проверим если null)
      
      if (isAuthFromProps === null) {
        try {
          setIsChecking(true)
          const authenticated = await isAuthenticated()
          if (isMounted) {
            setIsAuth(authenticated)
            // Важно: обновляем состояние в App, чтобы разорвать цикл редиректов
            if (setIsAuthInApp) {
              setIsAuthInApp(authenticated)
            }
          }
        } catch (error) {
          console.error('Auth check error:', error)
          if (isMounted) {
            setIsAuth(false)
            if (setIsAuthInApp) {
              setIsAuthInApp(false)
            }
          }
        } finally {
          if (isMounted) {
            setIsChecking(false)
          }
        }
      } else {
        // Если пропс уже есть, просто синхронизируем
        setIsAuth(isAuthFromProps)
        setIsChecking(false)
      }
    }
    
    checkAuth()
    
    return () => {
      isMounted = false
    }
  }, [isAuthFromProps, setIsAuthInApp]) // Зависим от пропсов

  // Показываем загрузку пока проверяем аутентификацию
  if (isChecking) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    )
  }

  // Если авторизации нет - редирект. 
  // И так как мы обновили setIsAuthInApp(false), родитель тоже будет знать об этом
  if (!isAuth) {
    return <Navigate to="/admin/login" replace />
  }

  return children
}

export default ProtectedRoute